import {
  type ComponentServicesGenuinePart,
  Enum_Componentservicesgenuinepart_Genuineparttype,
} from '@/types/tis-cms/types';

export const formatPrice = (
  val: string | number | null | undefined,
  position: 'front' | 'back' | 'none' = 'back',
  unit: string = 'THB'
) => {
  const num: number = +(val ?? 0) || 0;
  const price = num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  if (position === 'none') {
    return price;
  }
  return (
    (position === 'front' ? `${unit} ` : '') +
    price +
    (position === 'back' ? ` ${unit}` : '')
  );
};
const PART_PREFIX = {
  [Enum_Componentservicesgenuinepart_Genuineparttype.Isuzu]:
    'อะไหล่แท้<span>อีซูซุ</span>',
  [Enum_Componentservicesgenuinepart_Genuineparttype.Tripetch]:
    'อะไหล่แท้<span>ตรีเพชร</span>',
  [Enum_Componentservicesgenuinepart_Genuineparttype.Bvp]:
    'อีซูซุเบสท์<span>แวรลู</span>',
};
export const getPartPrefix = (part: ComponentServicesGenuinePart) => {
  let prefix =
    part.genuinePartType !==
    Enum_Componentservicesgenuinepart_Genuineparttype.Part
      ? PART_PREFIX[part.genuinePartType ?? '']
      : !!part.showTitle && !!part.title
        ? part.title
        : '';
  prefix = part.showStartPricePrefix ? `${prefix}` : prefix;

  return prefix;
};

export const formatNumber = (val: string, decimal = 0) => {
  if (isNaN(Number(val))) {
    return '-';
  }
  return Number(val) === 0 ? '-' : Number(val).toFixed(decimal);
};

export const stripHtmlTags = (html?: string): string => {
  if (!html) return '';
  return html.replace(/<[^>]*>/g, '').trim();
};

export const stripSpanTags = (html?: string): string => {
  if (!html) return '';
  return html.replace(/<\/?span[^>]*>/g, '').trim();
};

export const formatDateFull = (date: string | number | Date) => {
  const _date = new Date(date);
  return _date.toLocaleDateString('th-TH', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
};

export const formatDateShort = (date: string | number | Date) => {
  const value = new Date(date);
  return value.toLocaleDateString('th-TH', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
};

export const formatTel = (input: string, stripDash = false) => {
  let digits = input;

  if (!digits.startsWith('0')) {
    digits = `0${digits}`;
  }

  let extension = '';

  // find extension
  const parts = input.split('-');
  if (parts.length > 1) {
    const lastPart = parts[parts.length - 1];
    if (lastPart.length <= 3 && /^\d+$/.test(lastPart)) {
      extension = lastPart;
      digits = parts.slice(0, -1).join('-');
    }
  }

  digits = digits.replace(/[^\d]/g, '');

  const mainNumber = digits.substring(0, 10);

  let formattedNumber = '';

  if (mainNumber.startsWith('02')) {
    // Bangkok numbers: 02-XXXXXXX
    const remaining = mainNumber.substring(2);
    formattedNumber = `02-${remaining}`;
  } else {
    // Other area codes: 0XX-XXXXXXX
    if (mainNumber.length >= 10) {
      formattedNumber = `${mainNumber.substring(0, 3)}-${mainNumber.substring(3)}`;
    } else if (mainNumber.length >= 6) {
      formattedNumber = `${mainNumber.substring(0, 3)}-${mainNumber.substring(3)}`;
    } else {
      formattedNumber = mainNumber;
    }
  }

  if (stripDash) {
    return digits;
  }

  if (extension) {
    formattedNumber += `-${extension}`;
  }

  return formattedNumber;
};

export const formatSlug = (value: string) => {
  return value.replace(/[/()]/g, '').replace(/ /g, '-').toLowerCase();
};

export const stripPTags = (text: string): string => {
  return text.replace(/<\/?p[^>]*>/g, '');
};

export const getRef = (fileSrc?: string | null, url?: string | null) => {
  const raw = (fileSrc ?? url ?? '') || '';
  if (!raw || /^(https?:\/\/)/.test(raw) || raw.startsWith('/')) return raw;
  return `/${raw}`;
};

export const removeEmptyTags = (text: string) => {
  // Remove <p> tags
  const withoutEmptyPTags = text.replace(/<p\b[^>]*>\s*<\/p>/gi, '');

  // Remove <span> tags
  const withoutEmptySpanTags = withoutEmptyPTags.replace(
    /<span\b[^>]*>\s*<\/span>/gi,
    ''
  );
  // Remove <br /> tags
  const withoutBrTags = withoutEmptySpanTags.replace(/<br\s*\/?>/gi, '');

  return withoutBrTags;
};
